import {Anchor, Center, Container, Group, LoadingOverlay, Paper, Text} from '@mantine/core';
import {ArrowNarrowLeft} from "tabler-icons-react";
import React from "react";
import {useNavigate} from "react-router-dom";
import PasswordForgottenForm from "../components/forms/PasswordForgottenForm";
import usePasswordForgotten from "../hooks/usePasswordForgotten";
import {Brand} from "../components/AppShell/_brand";

function PasswordForgotten() {
    const { loading, setFormData, onSubmit } = usePasswordForgotten();
    const navigate = useNavigate();

    return (
        <Container size={420} my={40}>
            <Paper withBorder shadow="md" radius="md" p="xl">
                <Center mb={"md"}>
                    <Brand/>
                </Center>

                <div style={{position: "relative"}}>
                    <LoadingOverlay visible={loading} />
                    <PasswordForgottenForm onSubmit={onSubmit} setValues={setFormData}/>
                </div>

                <Anchor onClick={() => navigate("/login")}>
                    <Group>
                        <ArrowNarrowLeft/>
                        <Text>Login</Text>
                    </Group>
                </Anchor>
            </Paper>
        </Container>
    );
}

export default PasswordForgotten;